<div class="container" [ngClass]="{ 'dark-mode': isDarkMode }">
    <p-card class="header w-full">
        <div class="header-content w-full flex justify-content-between align-items-center">
            <div class="logo-container">
                <img [src]="companyLogo" alt="{{companyInfo[0]?.companyName}}" class="logo-image">
            </div>
          <div class="actions flex align-items-center" style="position: relative;">
            <!-- Mobile Menu Toggle + Menu -->
            <div class="menu-bar">
            <div class="mobile-menu-wrapper">
                <div class="mobile-menu-toggle" (click)="toggleMenu()">&#9776;</div>
                <div *ngIf="menuVisible" class="mobile-menu-overlay">
                <p-panelMenu
                    [model]="menuTree"
                    class="panel-menu-1"
                    (onNodeSelect)="onMenuItemSelect($event)">
                </p-panelMenu>
                </div>
            </div>
            </div>
            <button type="button"
                    title="Support"
                    class="action-btn pi pi-comments support-icon"
                    (click)="onSupportClick()">
            </button>
            
            <!-- <button type="button"
                    title="Notifications"
                    class="action-btn pi pi-bell notification-bell"
                    (click)="notificationPanel.toggle($event)">
              <span *ngIf="notifications.length > 0" class="notification-badge">
                {{ notifications.length }}
              </span>
            </button>
            <p-overlayPanel #notificationPanel
                [dismissable]="true" 
                [showCloseIcon]="true" 
                appendTo="body" 
                styleClass="notification-panel-custom">
              <ng-template pTemplate="content" Style="margin-right: 500px;" >
                <div *ngIf="notifications.length > 0; else noNotification" class="notification-list">
                  <div *ngFor="let note of notifications"
                      class="notification-item"
                      [innerHTML]="note.formattedMessage"
                      [ngClass]="{'po-notification': note.message.includes('LL\\'), 'task-notification': !note.message.includes('LL\\')}">
                  </div> 
                </div>
                <ng-template #noNotification>
                  <div class="notification-empty">No notifications</div>
                </ng-template>
              </ng-template>
            </p-overlayPanel> -->

          <button type="button" title="Notifications" class="action-btn pi pi-bell notification-bell"
            (click)="notificationPanel2.toggle($event)">
            <span *ngIf="notificationDto.length > 0" class="notification-badge">
              {{ notificationDto.length }}
            </span>
          </button>

          <p-overlayPanel #notificationPanel2 [dismissable]="true" [showCloseIcon]="true" appendTo="body" 
            styleClass="notification-panel-custom">
            <ng-template pTemplate="content">
              <ul *ngIf="notificationDto.length > 0; else noNotification" class="notification-list">
                <li *ngFor="let notification of notificationDto; let i = index" class="notification-item">
                  <div [innerHTML]="notification.message" (click)="handleClick($event)"></div>
                  <small class="text-muted">({{ notification.createdDate | date: 'dd/MM/yyyy, h:mm a' }})</small> 
                  <button type="button" class="close-btn" (click)="dismissNotification(i)">×</button>
                </li>
              </ul>

              <ng-template #noNotification>
                <div class="notification-empty">No notifications</div>
              </ng-template>
            </ng-template>
          </p-overlayPanel>


  <button type="button" title="screensize" (mouseenter)="screensize.toggle($event)" class="action-btn pi pi-desktop"></button>
  <button type="button" title="Dark Mode" (click)="darkMode()" class="action-btn">
    <i class="pi" [ngClass]="isDarkMode ? 'pi-moon' : 'pi-sun'"></i>
  </button>
  <p-avatar label="{{userAvatar}}" styleClass="avatar mr-2" shape="circle" (click)="op.toggle($event)"></p-avatar>
  <p-overlayPanel #op>
<ng-template pTemplate="content">
  <div class="user-profile-wrapper">

    <div class="user-header-vertical">
      <p-avatar
        label="{{ userAvatar }}"
        shape="circle"
        styleClass="dropdown-avatar-vertical"
      ></p-avatar>
      <div class="user-fullname-vertical">
        {{ loginResponse?.user?.firstName }} {{ loginResponse?.user?.lastName }}
      </div>
    </div>

    <button pButton type="button" icon="pi pi-sign-out" label="Sign Out" class="signout-btn p-button-rounded p-button-danger p-button-sm" (click)="logout()"></button>

    <div class="help-section">
      <div class="help-title">HELP DOCUMENTS</div>

      <div class="help-item" (click)="openHelp('user-guide')">
        <div class="help-icon bg-purple">
          <i class="pi pi-book"></i>
        </div>
        <span>User Guide</span>
      </div>

      <div class="help-item" (click)="openHelp('dev-guide')">
        <div class="help-icon bg-indigo">
          <i class="pi pi-code"></i>
        </div>
        <span>Developer Guide</span>
      </div>

      <div class="help-item" (click)="openHelp('faqs')">
        <div class="help-icon bg-red">
          <i class="pi pi-question-circle"></i>
        </div>
        <span>FAQs</span>
      </div>

      <div class="help-item" (click)="openHelp('contact')">
        <div class="help-icon bg-green">
          <i class="pi pi-phone"></i>
        </div>
        <span>Contact Us</span>
      </div>
    </div>
  </div>
</ng-template>
  </p-overlayPanel>
  <p-overlayPanel #screensize>
    <ng-template pTemplate="content">
      <span class="flex">
        <button type="button" (click)="decrease()" class="action-btn pi pi-minus"></button>
        <button type="button" (click)="increase()" class="action-btn pi pi-plus"></button>
      </span>
    </ng-template>
  </p-overlayPanel>
</div>
        </div>
    </p-card>
    <div class="content flex mt-2">

        <!-- <div>
            <p-card class="w-full h-full p-card-1">
                <p-panelMenu [model]="menuTree" class="panel-menu-1"></p-panelMenu>
            </p-card>
        </div> -->
          <!-- Desktop Menu -->
        <div class="menu-bar">
            <div class="desktop-menu">
                 <p-card class="w-full h-full p-card-1">
                <p-panelMenu [model]="menuTree" class="panel-menu-1"></p-panelMenu>
            </p-card>
             </div>
        </div>
        <div class="w-full text-center pl-1">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<footer>  Mapsoft Technologies © {{ currentYear }} All Rights Reserved </footer>
